import { useEffect, useRef, useState } from "react";
import { useSearchParams, useNavigate, Link } from "react-router-dom";
import { useAuth } from "@/context/AuthContext";
import { apiErr } from "@/lib/api";
import { Logo } from "@/components/Logo";

export default function VerifyEmail() {
  const [params] = useSearchParams();
  const navigate = useNavigate();
  const { verifyEmail } = useAuth();
  const [status, setStatus] = useState("verifying"); // verifying | success | error
  const [message, setMessage] = useState("");
  const processed = useRef(false);

  useEffect(() => {
    if (processed.current) return;
    processed.current = true;
    const token = params.get("token");
    if (!token) {
      setStatus("error");
      setMessage("This verification link is missing its token.");
      return;
    }
    (async () => {
      try {
        const user = await verifyEmail(token);
        setStatus("success");
        setTimeout(() => navigate(user.role === "admin" ? "/admin" : "/dashboard", { replace: true }), 1500);
      } catch (err) {
        setStatus("error");
        setMessage(apiErr(err));
      }
    })();
  }, [params, verifyEmail, navigate]);

  return (
    <div className="min-h-[70vh] flex items-center justify-center px-6" data-testid="verify-email-page">
      <div className="w-full max-w-md text-center">
        <div className="flex justify-center mb-8"><Logo /></div>
        {status === "verifying" && (
          <p className="text-slate-500" data-testid="verify-loading">Verifying your email…</p>
        )}
        {status === "success" && (
          <div data-testid="verify-success">
            <h1 className="font-display text-3xl font-bold text-navy">Email verified ✓</h1>
            <p className="mt-3 text-slate-500">You're all set. Taking you to your dashboard…</p>
          </div>
        )}
        {status === "error" && (
          <div data-testid="verify-error">
            <h1 className="font-display text-3xl font-bold text-navy">Verification failed</h1>
            <p className="mt-3 text-red-600">{message}</p>
            <Link to="/login" className="mt-6 inline-block text-navy font-semibold hover:text-gold" data-testid="verify-go-login">
              Go to Login
            </Link>
          </div>
        )}
      </div>
    </div>
  );
}
